// candidates/registrations.js
import { buildForm } from '../forms';
import IMask from 'imask';
import $ from 'jquery';

$(document).ready(function () {

	buildForm(document);

	IMask(document.getElementById("candidate_candidate_profile_attributes_cellphone"), { mask: [
		{
			mask: '00 0000-0000'
		},
		{
			mask: '00 00000-0000'
		},
		{
			mask: '\\+00 00 00000-0000'
		} ]
	});

	IMask(document.getElementById("candidate_candidate_profile_attributes_birthdate"), { mask: [
		{
			mask: '00/00/0000'
		}]
	});

	IMask(document.getElementById("candidate_document_number"), { mask: [
		{
			mask: '000.000.000-00'
		}]
	});

	var toggleGenderPlusVisibility = function(){
		if($("#candidate_candidate_profile_attributes_gender").val() === "O"){
			$(".gender-plus--field").css('visibility', 'visible');
		} else {
			$(".gender-plus--field").css('visibility', 'hidden');
		}
	}
	
	$("#candidate_candidate_profile_attributes_gender").on('change',toggleGenderPlusVisibility);
	toggleGenderPlusVisibility();

	const termsCheck = $('#terms-of-use-check');
	const policyCheck = $('#privacy-policy-check');

	var enableSubmit = function(){
		$('.form-submit-button').prop('disabled', false).removeClass('disabled');
		$('.accepts-warning').hide();
	}

	var disableSubmit = function(){
		$('.form-submit-button').prop('disabled', true).addClass('disabled');
		$('.accepts-warning').show();
	}

	var toggleSubmit = function(){
		if(termsCheck.is(':checked') && policyCheck.is(':checked')){
			enableSubmit();
		} else {
			disableSubmit();
		}
	}
	
	termsCheck.on('change', toggleSubmit);
	policyCheck.on('change', toggleSubmit);

	toggleSubmit();

	const fileInput = document.getElementById('linkedin_pdf');
	const fileNameDisplay = document.getElementById('file-name');
	const linkedinLoader = document.getElementById('likedin-loader');
	const uploadBtn = document.getElementById('upload-btn');
	const uploadLabel = document.getElementById('upload-label');

	const nameInput = document.getElementById('candidate_candidate_profile_attributes_name');
	const lastNameInput = document.getElementById('candidate_candidate_profile_attributes_lastname');
	const emailInput = document.getElementById('candidate_email');
	const cityInput = document.getElementById('candidate_candidate_profile_attributes_city');
	const linkedinDataInput = document.getElementById("linkedin_data")
	const linkedinApiPreview = document.getElementById("linkedin-api-preview")
	const retryBtn = document.getElementById("retry-btn")

	if (linkedinDataInput.value !== "") {
		linkedinApiPreview.style.display = 'block';
		linkedinInfoInsert(JSON.parse(linkedinDataInput.value));
	}

	retryBtn.addEventListener("click", observerCallback);

	uploadBtn.addEventListener('click', () => {
		fileNameDisplay.textContent = 'Nenhum arquivo selecionado';
		fileInput.value = '';
	});

	fileInput.addEventListener('change', function () {
		if (fileInput.files.length > 0) {
			fileNameDisplay.textContent = fileInput.files[0].name;
		} else {
			fileNameDisplay.textContent = 'Nenhum arquivo selecionado';
		}
	});

	const observer = new MutationObserver(observerCallback);

	observer.observe(fileNameDisplay, { childList: true });

	function observerCallback(params) {
		if (fileNameDisplay.textContent !== 'Nenhum arquivo selecionado') {
			linkedinLoader.classList.remove('hidden');
			uploadLabel.classList.add('button-disabled');

			const loadingMsg = document.getElementById('loading-msg');
			const progressBar = document.getElementById('progress-bar-id');

			const messages = [
			"Estamos processando seu perfil...",
			"Fazendo a mágica acontecer...",
			"Extraindo as informações...",
			"Quase lá! ⏳"
			];

			let msgIndex = 0;
			loadingMsg.textContent = "Subindo Arquivo PDF";

			const msgInterval = setInterval(() => {
			msgIndex = (msgIndex + 1) % messages.length;
			loadingMsg.textContent = messages[msgIndex];
			}, 10000);

			progressBar.style.backgroundColor = '#30306E';
			progressBar.style.animation = '';
			progressBar.style.animationPlayState = 'running'; 
			progressBar.classList.remove('progress-bar');
			void progressBar.offsetWidth;
			progressBar.classList.add('progress-bar');

			const formData = new FormData();
			formData.append('file', fileInput.files[0]);

			fetchWithRetryImmediate('https://n8n.trampos.co/webhook/create-candidate', {
				method: 'POST',
				body: formData
			})
			.then(data => {
				clearInterval(msgInterval);
				progressBar.style.width = '100%';

				setTimeout(() => {
				linkedinLoader.classList.add('hidden');
				}, 1000);

				uploadLabel.classList.remove('button-disabled');
				linkedinApiPreview.style.display = 'block';

				console.log(data)
				linkedinDataInput.value = JSON.stringify(data);

				linkedinInfoInsert(data)

				if (data.Contact?.FirstName) nameInput.value = data.Contact.FirstName;
				if (data.Contact?.LastName) lastNameInput.value = data.Contact.LastName;
				if (data.Contact?.Email) emailInput.value = data.Contact.Email;
				if (data.Contact?.Location) {
					const city_state = data.Contact.Location.split(",").map(part => part.trim());
					if (city_state[0]) cityInput.value = city_state[0];
				}
			})
			.catch(err => {
				clearInterval(msgInterval);
				progressBar.style.animationPlayState = 'paused';
				progressBar.style.backgroundColor = 'red';
				uploadLabel.classList.remove('button-disabled');
				console.error('Erro na API:', err);
				document.getElementById('loading-msg').textContent = "Ocorreu um erro inesperado. Tente Novamente!";
				retryBtn.classList.remove("hidden");
			});
		} else {
			linkedinLoader.classList.add('hidden');
		}

	}
	function linkedinInfoInsert(data) {
		const name = data.Contact?.Name || '';
		const email = data.Contact?.Email || '';
		const phone = data.Contact?.Phone || '';
		const linkedin = data.Contact?.Linkedin || '';
		const location = data.Contact?.Location || '';

		document.getElementById('api-name').textContent = name || '-';
		document.getElementById('api-email').textContent = email || '-';
		document.getElementById('api-telefone').textContent = phone || '-';
		document.getElementById('api-linkedin').textContent = linkedin || '-';
		document.getElementById('api-location').textContent = location || '-';
		toggleSection('contact', name || email || phone || linkedin || location);

		const summary = data.Summary || '';
		document.getElementById('api-summary').textContent = summary || '-';
		toggleSection('summary', summary);

		const headline = data.Headline || '';
		document.getElementById('api-headline').textContent = headline || '-';
		toggleSection('position', headline);

		const skills = Array.isArray(data.TopSkills) ? data.TopSkills : [];
		document.getElementById('api-skills').innerHTML = skills.map(skill => `<li>${skill}</li>`).join('');
		toggleSection('skills', skills.length > 0);

		const lang = Array.isArray(data.Languages) ? data.Languages : [];
		document.getElementById('api-languages').innerHTML = lang.map(lang=> `<li>${lang["language"]}</li>`).join('');
		toggleSection('lang', lang.length > 0);

		const certs = Array.isArray(data.Certifications) ? data.Certifications : [];
		document.getElementById('api-certifications').innerHTML = certs.map(cert => `<li>${cert}</li>`).join('');
		toggleSection('certifications', certs.length > 0);

		const experience = Array.isArray(data.Experience) ? data.Experience : [];
		document.getElementById('api-experience').innerHTML = experience.map(exp => {
		const start = formatDateBR(exp.Period?.Start);
		const end = formatDateBR(exp.Period?.End);
		const dateRange = (start || end) ? `${start || '-'} até ${end || '-'}` : '';
		return `
			<li>
			<strong>${exp.Title || '-'}</strong> na ${exp.Company || '-'}<br />
			${dateRange ? `<em>${dateRange}</em><br />` : ''}
			<small>${exp.Location || '-'}</small>
			</li>
		`;
		}).join('');
		toggleSection('experience', experience.length > 0);

		const education = Array.isArray(data.Education) ? data.Education : [];
		document.getElementById('api-education').innerHTML = education.map(edu => {
		const start = formatDateBR(edu.Period?.Start);
		const end = formatDateBR(edu.Period?.End);
		const dateRange = (start || end) ? `${start || '-'} até ${end || '-'}` : '';
		return `
			<li>
			<strong>${edu.Degree || '-'}</strong> - ${edu.School || '-'}<br />
			${dateRange ? `<em>${dateRange}</em>` : ''}
			</li>
		`;
		}).join('');
		toggleSection('education', education.length > 0);

		function toggleSection(className, condition) {
			const section = document.querySelector(`.accordion-${className}`);
			if (section) section.style.display = condition ? '' : 'none';
		}

		function formatDateBR(dateStr) {
			if (!dateStr) return '';
			if (typeof dateStr !== 'string') return dateStr;
			if (dateStr.toLowerCase().includes('present')) return 'Atual';
			const parts = dateStr.split('-');
			if (parts.length === 3) {
				const [year, month, day] = parts;
				return `${day}/${month}/${year}`;
			}
			return dateStr;
		}
	}

	async function fetchWithRetryImmediate(url, options, maxRetries = 2) {
		let attempt = 0;
		retryBtn.classList.add("hidden");
		while (attempt < maxRetries) {
			try {
				const res = await fetch(url, options);
				if (!res.ok) throw new Error(`Erro HTTP: ${res.status}`);
				return await res.json();
			} catch (err) {
				attempt++;
				console.error(`Tentativa ${attempt} falhou:`, err);

				if (attempt >= maxRetries) {
					throw err;
				}

				console.log(`Tentando novamente... (${attempt + 1}/${maxRetries})`);

			}
		}
	}

});